import React from 'react';
import { AlertTriangle } from 'lucide-react';
export function PainSection() {
  return <section className="w-full bg-navy-light py-20 px-4 border-t border-white/5" data-id="element-123" data-mp="38xom34brb0z8">
      <div className="max-w-4xl mx-auto" data-id="element-124" data-mp="2uy5oh5gkn816">
        <div className="flex items-center gap-3 mb-8" data-id="element-125" data-mp="2ux41q3q70x3m">
          <AlertTriangle className="w-8 h-8 text-danger" data-id="element-126" data-mp="2yzqwace90w4i" />
          <h2 className="text-2xl md:text-3xl font-headline font-bold text-white uppercase tracking-wide" data-id="element-127" data-mp="2yy5zsh8dj340">
            Sección 1: La Confrontación con la Realidad
          </h2>
        </div>

        <div className="space-y-8 text-lg md:text-xl text-gray-300 leading-relaxed" data-id="element-128" data-mp="2pzud2qamopgu">
          <p data-id="element-129" data-mp="2bb7orz30wndh">
            Si eres un padre con un hijo entre 8 y 16 años que{' '}
            <span className="text-white font-bold" data-id="element-130" data-mp="2g8pznv0lpco4">"la rompe"</span> en la
            cancha, seguramente has sentido este nudo en el estómago:
          </p>

          <div className="bg-navy p-6 rounded-lg border-l-4 border-danger/70 shadow-lg" data-id="element-131" data-mp="22bkurycmijug">
            <p className="italic text-gray-200" data-id="element-132" data-mp="277rqyzf7wgz7">
              "Ves a niños con la mitad del talento de tu hijo, pero con padres
              que tienen mejores conexiones o chequeras más grandes, quedándose
              con los puestos titulares en los mejores equipos."
            </p>
          </div>

          <p data-id="element-133" data-mp="5dq44e2r1mdt">
            Ves a tu hijo esforzarse cada entrenamiento, solo para seguir
            estancado en el nivel "Recreational" o en una academia local donde
            el entrenador solo se sabe el nombre de tu hijo cuando toca pagar la
            cuota.
          </p>

          <p className="font-bold text-white text-xl md:text-2xl border-b border-danger/30 pb-4 inline-block" data-id="element-134" data-mp="33z15mrm7rfvr">
            Tengo una verdad amarga para ti:
          </p>

          <p data-id="element-135" data-mp="3dvclfrl0inuy">
            En los Estados Unidos, el fútbol no es un deporte de "suerte".{' '}
            <span className="text-danger font-bold" data-id="element-136" data-mp="2q59s785d3bur">
              Es un sistema de pago por visibilidad.
            </span>{' '}
            Si no conoces las métricas secretas que los scouts anotan en su
            libreta, tu hijo seguirá siendo un "talento silencioso" hasta que
            sea demasiado tarde.
          </p>
        </div>
      </div>
    </section>;
}